import { render, staticRenderFns } from "./ExpenseTableHeader.vue?vue&type=template&id=c5534236&"
import script from "./ExpenseTableHeader.vue?vue&type=script&lang=js&"
export * from "./ExpenseTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports